// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"icon-cards_wrapper__paVbO"};